module.exports = __webpack_public_path__ + "static/assets/d687b0a389aebcfb6110b83445a26e53.png";